<form [formGroup]="personalDetailsForm()">
    <p>{{ 'appointment.intro.main' | apContent }}</p>

    <div class="ap-margin-top-1">
        <ap-radio-group
            data-bb="genderRadioGroup"
            [description]="'appointment.header.gender' | apContent"
            [descriptionHidden]="true"
            [messages]="getErrorMessage('appointment.header.gender')"
            [inline]="true"
            [control]="personalDetailsForm().controls.gender"
        >
            <ap-radio-button
                data-bb="genderRadioButton"
                [label]="'appointment.label.gender.female' | apContent"
                name="gender"
                [formControl]="personalDetailsForm().controls.gender"
                [value]="gender.V"
            >
            </ap-radio-button>
            <ap-radio-button
                data-bb="genderRadioButton"
                [label]="'appointment.label.gender.male' | apContent"
                name="gender"
                [formControl]="personalDetailsForm().controls.gender"
                [value]="gender.M"
            >
            </ap-radio-button>
        </ap-radio-group>
    </div>
    <div class="ap-flex ap-gap-gt-md-4 ap-flex-lt-lg-wrap">
        <div class="ap-flex-basis-25 ap-flex-lt-lg-fill">
            <ap-input
                data-bb="initialInput"
                label="{{ 'appointment.label.initials' | apContent }}"
                formControlName="initials"
                [messages]="getErrorMessage('appointment.label.initials')"
                (inputBlur)="transformValue('initials')"
            >
            </ap-input>
        </div>

        <div class="ap-flex-basis-50 ap-flex-lt-lg-fill">
            <ap-input
                data-bb="firstNameInput"
                label="{{ 'appointment.label.first_name' | apContent }}"
                formControlName="firstName"
                [messages]="getErrorMessage('appointment.label.first_name')"
                (inputBlur)="transformValue('firstName')"
            >
            </ap-input>
        </div>

        <div class="ap-flex-basis-25 ap-flex-lt-lg-fill">
            <ap-input
                data-bb="prefixInput"
                label="{{ 'appointment.label.prefix' | apContent }}"
                formControlName="prefix"
                [messages]="getErrorMessage('appointment.label.prefix')"
            >
            </ap-input>
        </div>
        <div class="ap-flex-basis-50 ap-flex-lt-lg-fill">
            <ap-input
                data-bb="familyNameInput"
                label="{{ 'appointment.label.family_name' | apContent }}"
                formControlName="familyName"
                [messages]="getErrorMessage('appointment.label.family_name')"
                (inputBlur)="transformValue('familyName')"
            >
            </ap-input>
        </div>
    </div>

    <ap-date-input
        data-bb="dateOfBirthInput"
        label="{{ 'appointment.label.date_of_birth_format' | apContent }}"
        formControlName="dateOfBirth"
        [minDate]="getMinDate()"
        [maxDate]="getMaxDate()"
        [messages]="getErrorMessage('appointment.label.date_of_birth')"
    >
    </ap-date-input>
</form>
